module.exports = __webpack_public_path__ + "img/ZWF_Rafael_Nikita.c13d3dc8.jpg";